// Must match the server enum
export enum CustomFieldsGroupNameType {
  None = 'none',
  AssetOptionalDetail = 'assetOptionalDetail',
  AssetInvestmentOptionalDetails  = 'assetInvestmentOptionalDetails',
  ContactOptionalDetails = 'contactOptionalDetails',
}

